export default class QuestionnaireStartButtonEntity {
  constructor(description, url = null) {
    this.description = description
    this.url = url
    this.isVisible = false
    this.isActive = true
    this.updatedAt = new Date()
  }

  init(description, isExpired, isAnswered) {
    this.description = description
    this.isVisible = !isExpired && isAnswered
    this.isActive = !isAnswered
    this.updatedAt = new Date()
  }

  show() {
    this.isVisible = true
    this.updatedAt = new Date()
  }

  active() {
    this.isVisible = true
    this.isActive = true
    this.updatedAt = new Date()
  }

  inactive() {
    this.isVisible = true
    this.isActive = false
    this.updatedAt = new Date()
  }
}
